export const iconImages = [
    {
        src: require("../../../../assets/3. Maghzi Law - Favicon 1.png"),
        width: 128,
        height: 128,
        alt: "Maghzi Law Favicon",
    },
    {
        src: require("../../../../assets/2. Romanovsky Law Offices - Favicon 1.png"),
        width: 192,
        height: 192,
        alt: "Romanovsky Law Offices Favicon",
    },
    {
        src: require("../../../../assets/4. Centurion Legal Group 1.png"),
        width: 128,
        height: 128,
        alt: "Centurion Legal Group",
    },
    {
        src: require("../../../../assets/1. Massa Viana Law - Favicon 1.png"),
        width: 192,
        height: 192,
        alt: "Massa Viana Law Favicon",
    },
    {
        src: require("../../../../assets/Brink-Immigration-Orlando 1.png"),
        width: 190,
        height: 175,
        alt: "Brink Immigration Orlando",
    },
    {
        src: require("../../../../assets/Robichaud_-Schroepfer-_-Correia_-P.A.-Logo 1.png"),
        width: 299,
        height: 133,
        alt: "Robichaud Schroepfer Correia P.A. Logo",
    },
];